import ReactDOM from 'react-dom'
import React from 'react';
import './Coptcha.css';

const GRIDS = [
  {
    "id": 1,
    "subject": "a law-abiding citizen",
    "images": [
      {"matches": 1, "src": "015", "alt": "White child"},
      {"matches": 2, "src": "020", "alt": "Man opening car door"},
      {"matches": 1, "src": "014", "alt": "White person with drink"},

      {"matches": 1, "src": "023", "alt": "Two white women walking"},
      {"matches": 1, "src": "019", "alt": "Person in front of store"},
      {"matches": 1, "src": "011", "alt": "Black person enjoying some coffee"},

      {"matches": 1, "src": "016", "alt": "White woman"},
      {"matches": 1, "src": "021", "alt": "Two black women walking"},
      {"matches": 0, "src": "025", "alt": "Man peeing against car"},
    ],
  },
  {
    "id": 2,
    "subject": "law-abiding citizens",
    "images": [
      {"matches": 1, "src": "045", "alt": "Black person walking"},
      {"matches": 0, "src": "048", "alt": "White people fighting"},
      {"matches": 0, "src": "042", "alt": "Rioting Trump supporters"},

      {"matches": 2, "src": "049", "alt": "Man being held by two people"},
      {"matches": 0, "src": "050", "alt": "Fight in front of store"},
      {"matches": 1, "src": "012", "alt": "Black man walking"},

      {"matches": 2, "src": "051", "alt": "White man steals car"},
      {"matches": 0, "src": "052", "alt": "Street fight"},
      {"matches": 2, "src": "054", "alt": "Masked people in overalls"},
    ],
  },
  {
    "id": 3,
    "subject": "police brutality",
    "images": [
      {"matches": 2, "src": "055", "alt": "Police officer hits protester"},
      {"matches": 1, "src": "057", "alt": "Police officer points gun at protester"},
      {"matches": 1, "src": "056", "alt": "Police officers use pepper spray on protester"},

      {"matches": 2, "src": "058", "alt": "Police officers hold a man down"},
      {"matches": 1, "src": "059", "alt": "Police officers hold a man down"},
      {"matches": 1, "src": "060", "alt": "Police officers attack man"},

      {"matches": 2, "src": "061", "alt": "Police officer attacks man with “End police violence” sign"},
      {"matches": 1, "src": "062", "alt": "Police officer assaults woman"},
      {"matches": 0, "src": "063", "alt": "Police officer has conversation with a homeless person"},
    ],
  },
  {
    "id": 4,
    "subject": "ridiculous use of taxpayers' money",
    "images": [
      {"matches": 2, "src": "064", "alt": "SWAT gear"},
      {"matches": 2, "src": "065", "alt": "SWAT helicopter"},
      {"matches": 1, "src": "066", "alt": "SWAT vehicle"},

      {"matches": 0, "src": "067", "alt": "School meals"},
      {"matches": 0, "src": "068", "alt": "Doctor"},
      {"matches": 2, "src": "069", "alt": "Spectre gunship"},

      {"matches": 1, "src": "070", "alt": "SWAT tank with police officer"},
      {"matches": 1, "src": "071", "alt": "SWAT vehicle"},
      {"matches": 1, "src": "072", "alt": "LAPD helicopter and Lamborghini"},
    ],
  },
 /*
  {
    "id": 5,
    "subject": "",
    "images": [
      {"matches": 1, "src": "034", "alt": "Ku Klux Klan"},
      {"matches": 0, "src": "036", "alt": "Black woman with “Is my son next” sign"},
      {"matches": 0, "src": "044", "alt": "BLM sit-in"},

      {"matches": 0, "src": "037", "alt": "Woman with “Colour is not a crime!” sign"},
      {"matches": 0, "src": "053", "alt": "Black marching band"},
      {"matches": 1, "src": "035", "alt": "Trump supporters in capitol"},

      {"matches": 1, "src": "043", "alt": "Rioting Trump supporters"},
      {"matches": 1, "src": "042", "alt": "Rioting Trump supporters"},
      {"matches": 1, "src": "047", "alt": "Second amendment protest"},
    ],
  },
  */
  {
    "id": 6,
    "subject": "aggression",
    "images": [
      {"matches": 0, "src": "023", "alt": "Two white women walking"},
      {"matches": 0, "src": "006", "alt": "Black person in hoodie"},
      {"matches": 1, "src": "050", "alt": "Fight in front of store"},

      {"matches": 0, "src": "005", "alt": "Asian person waving"},
      {"matches": 1, "src": "017", "alt": "White people fighting"},
      {"matches": 0, "src": "024", "alt": "Spock in a robe"},

      {"matches": 1, "src": "040", "alt": "White people in a fight"},
      {"matches": 0, "src": "021", "alt": "Two black women walking"},
      {"matches": 1, "src": "046", "alt": "Angry white woman points gun at someone"},
    ],
  },
  {
    "id": 7,
    "subject": "white trash",
    "images": [
      {"matches": 0, "src": "022", "alt": "A bicycle"},
      {"matches": 2, "src": "017", "alt": "White people fighting"},
      {"matches": 0, "src": "003", "alt": "Blue trash bags"},

      {"matches": 0, "src": "009", "alt": "Blue trash bags"},
      {"matches": 0, "src": "026", "alt": "Paper recycling container"},
      {"matches": 0, "src": "027", "alt": "Person standing with bag"},

      {"matches": 1, "src": "013", "alt": "White trash bags"},
      {"matches": 0, "src": "004", "alt": "USPS mailbox"},
      {"matches": 2, "src": "040", "alt": "White people in a fight"},
    ],
  },
  /*
  {
    "id": 8,
    "subject": "garbage",
    "images": [
      {"matches": 0, "src": "004", "alt": "USPS mailbox"},
      {"matches": 1, "src": "013", "alt": "White trash bags"},
      {"matches": 1, "src": "003", "alt": "Blue trash bags"},

      {"matches": 0, "src": "002", "alt": "Garden decoration"},
      {"matches": 0, "src": "018", "alt": "Black person with shovel and some bins"},
      {"matches": 1, "src": "010", "alt": "Garbage can in park"},

      {"matches": 0, "src": "001", "alt": "Fire hydrant"},
      {"matches": 1, "src": "009", "alt": "Blue trash bags"},
      {"matches": 2, "src": "008", "alt": "Black person on trash can"},
    ],
  },
  */
  {
    "id": 9,
    "subject": "dangerous extremists",
    "images": [
      {"matches": 1, "src": "034", "alt": "Ku Klux Klan"},
      {"matches": 1, "src": "039", "alt": "White man with rifle"},
      {"matches": 0, "src": "073", "alt": "Bernie Sanders"},

      {"matches": 0, "src": "036", "alt": "Black woman with “Is my son next” sign"},
      {"matches": 1, "src": "042", "alt": "Rioting Trump supporters"},
      {"matches": 1, "src": "035", "alt": "Trump supporters in capitol"},

      {"matches": 0, "src": "005", "alt": "Asian person waving"},
      {"matches": 0, "src": "028", "alt": "White man"},
      {"matches": 0, "src": "037", "alt": "Black woman with “Colour is not a crime” sign"},
    ],
  },
  {
    "id": 10,
    "subject": "dangerous extremists",
    "images": [
      {"matches": 1, "src": "034", "alt": "Ku Klux Klan"},
      {"matches": 1, "src": "046", "alt": "Angry white woman points gun at someone"},
      {"matches": 0, "src": "032", "alt": "Alexandria Ocasio-Cortez"},

      {"matches": 0, "src": "036", "alt": "Black woman with “Is my son next” sign"},
      {"matches": 0, "src": "038", "alt": "White woman with “Black lives matter” sign"},
      {"matches": 1, "src": "035", "alt": "Trump supporters in capitol"},

      {"matches": 1, "src": "047", "alt": "Second amendment protest"},
      {"matches": 0, "src": "028", "alt": "White man"},
      {"matches": 0, "src": "037", "alt": "Black woman with “Colour is not a crime” sign"},
    ],
  },
  {
    "id": 11,
    "subject": "islamic extremists",
    "images": [
      {"matches": 0, "src": "005", "alt": "Asian person waving"},
      {"matches": 0, "src": "025", "alt": "Man peeing against car"},
      {"matches": 0, "src": "030", "alt": "Barack Obama"},

      {"matches": 1, "src": "041", "alt": "IS members with rifles"},
      {"matches": 0, "src": "029", "alt": "Mahatma Gandhi"},
      {"matches": 0, "src": "028", "alt": "White man"},

      {"matches": 0, "src": "006", "alt": "Black person in hoodie"},
      {"matches": 0, "src": "023", "alt": "Two white women walking"},
      {"matches": 0, "src": "031", "alt": "E.T. covered in blanket"},
    ],
  },
  {
    "id": 12,
    "subject": "aliens that should go back to where they came from",
    "images": [
      {"matches": 0, "src": "014", "alt": "White person with drink"},
      {"matches": 0, "src": "011", "alt": "Black person enjoying some coffee"},
      {"matches": 2, "src": "024", "alt": "Spock in a robe"},

      {"matches": 0, "src": "007", "alt": "Kids"},
      {"matches": 0, "src": "012", "alt": "Black man walking"},
      {"matches": 0, "src": "020", "alt": "Man opening car door"},

      {"matches": 1, "src": "031", "alt": "E.T."},
      {"matches": 0, "src": "033", "alt": "Person with broom"},
      {"matches": 0, "src": "021", "alt": "Two black women walking"},
    ],
  },
];

function matches(expectedAnswers, actualAnswers) {
  let rightAnswers = 0;
  for (const answer in actualAnswers) {
    if (actualAnswers[answer] && parseInt(expectedAnswers[answer]) === 0) {
      return -1;
    }
    if (!actualAnswers[answer] && parseInt(expectedAnswers[answer]) === 1) {
      continue;
    }
    rightAnswers++;
  }
  return rightAnswers / 9;
}

function verify(event) {
  const document = event.view.document;

  // 1 = matches, 2 = doesn’t matter
  const expectedMatches = [...document.getElementById('grid').children].map(child => child?.dataset.matches);
  const actualMatches = [...document.getElementById('grid').children].map(child => child?.className === "clicked");

  if (matches(expectedMatches, actualMatches) < 0) {
    document.getElementById('feedback-incorrect').className = 'enabled';
    document.getElementById('feedback-incomplete').className = '';
    return;
  }
  if (matches(expectedMatches, actualMatches) < .95) {
    document.getElementById('feedback-incorrect').className = '';
    document.getElementById('feedback-incomplete').className = 'enabled';
    return;
  }

  sleep(1000).then(() => {
    document.getElementById('feedback-incorrect').className = '';
    document.getElementById('feedback-incomplete').className = '';
    
    togglePopup(event);
  
    const checkbox = document.getElementById('checkbox');
    checkbox.className += ' hidden';
  
    const success = document.getElementById('success');
    success.className += ' visible';
    
    sleep(1500).then(() => {
      const outro = document.getElementById('outro');
      outro.className = 'visible';
    
      const overlay = document.getElementById('overlay');
      overlay.className = 'active dark';
    });
  });
}

function toggleSquare(event) {
  const span = event.target.parentElement;
  span.className = span.className === '' ? 'clicked' : '';
}

function reload(event) {
  const document = event.view.document;
  const excludedGrid = document.getElementById('challenge').dataset.grid;
  sleep(250)
    .then(() => {
      ReactDOM.render(popup(true, excludedGrid), document.getElementById('slot'))
    });
}

function toggleSquareViaKeyboard(event) {
  if (event.charCode === 13) {
    toggleSquare(event);
  }
}

function togglePopupViaKeyboard(event) {
  if (event.charCode === 13) {
    togglePopup(event);
  }
}

function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
  }
}

function sleep(milliseconds) {
  return new Promise(resolve => setTimeout(resolve, milliseconds));
}

function togglePopup(event) {
  const document = event.view.document;
  const challenge = document.getElementById('challenge');
  const overlay = document.getElementById('overlay');
  const success = document.getElementById('success');

  if (success.className === 'success visible') {
    return;
  }

  if (challenge.className === 'popup invisible') {
    sleep(220).then(() => {
      challenge.className = 'popup visible';
      overlay.className = 'active';
    });
  } else {
    challenge.className = 'popup invisible';
    overlay.className = '';
  }
}

function popup(active = false, exclude = null) {
  var grids = [...GRIDS];
  if (exclude) {
    grids = grids.filter(g => g.id !== parseInt(exclude))
  }

  const grid = grids[Math.floor(Math.random() * grids.length)];
  const subject = grid.subject;

  const images = [...grid.images];
  shuffleArray(images);

  return (
    <div id="challenge" className={'popup' + (active ? ' visible' : ' invisible')} data-grid={grid.id}>
      <header>
        <h2>
          Select all images with <strong>{subject}</strong>
        </h2>
      </header>
  
      <main id="grid" data-grid={grid.subject}>
        {images.map(image => (
          <div key={image.src + 'span'} data-matches={image.matches} onClick={toggleSquare}>
            <img
              key={image.src}
              src={'./images/' + image.src + '.jpg'}
              alt={image.alt}
              width="127"
              tabIndex="0"
              onKeyPress={toggleSquareViaKeyboard}
            />
          </div>
        ))}
      </main>
  
      <div className="feedback">
        <p id="feedback-incorrect">Please try again.</p>
        <p id="feedback-incomplete">Please select all matching images.</p>
      </div>
  
      <footer>
        <button className="verify" onClick={verify}>Verify</button>
        <div className="controls">
          <button className="reload" title="Reload" onClick={reload} style={ {"backgroundImage": "url('/refresh_2x.png')"} }>Reload</button>
        </div>
      </footer>
  
    </div>
  );
}

function restart() {
  ReactDOM.render(
    <React.StrictMode>
      <Coptcha />
    </React.StrictMode>,
    document.getElementById('coptcha')
  );
}

function Coptcha() {  
  return (
    <>
      <div className="form">
        <span className="checkboxContainer">
          <input id="check" type="checkbox"></input>
          <span tabIndex="0" id="checkbox" className="checkbox" onClick={togglePopup} onKeyPress={togglePopupViaKeyboard}></span>
          <span id="success" className="success"></span>
          <label htmlFor="check" onClick={togglePopup}>I'm not a police officer</label>
        </span>
        <div id="slot">{popup(false)}</div>
      </div>
      <div id="overlay" onClick={togglePopup}></div>
      <div id="outro">
        <p>
          The rest of this demo doesn’t work – just like
          the criminal justice system in the US (and many other countries).
        </p>
        <p>
          In the meantime, would you like to
          {' '}
          <a href="./" onClick={restart}>try another COPTCHA</a>?
        </p>
      </div>
    </>
  );
}

export default Coptcha;
